/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
import { InjectionToken } from '@angular/core';
/** *
 * Injection Token for notifier options
  @type {?} */
export var NotifierOptionsToken = new InjectionToken('[angular-notifier] Notifier Options');
/** *
 * Injection Token for notifier configuration
  @type {?} */
export var NotifierConfigToken = new InjectionToken('[anuglar-notifier] Notifier Config');
// tslint:enable variable-name
//# sourceMappingURL=notifier-token.js.map